import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { AuthenticationState } from '../models/models';

@Injectable({
  providedIn: 'root'
})
export class IntroGuard implements CanActivate {
  constructor(
    private auth: AuthService,
    private router: Router
  ) {}

  // Can only enter intro if the user is marked as a new user
  canActivate(_r: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    const authState = this.auth.authenticationState.value;
    if (authState === AuthenticationState.NotSet) {
      this.auth.orgRoute = state.url;
      return this.router.parseUrl('/startup');
    }
    else if (authState === AuthenticationState.NotAuthenticated) {
      return this.router.parseUrl('/sign-in');
    }
    else if (authState === AuthenticationState.NewUser) {
      return true;
    }
    else {
      return this.router.parseUrl('/home');
    }
  }
}
